import { Injectable } from '@angular/core';
import { Company, LocationGroup, MaintenanceType, Segment } from '@core/interfaces';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

export interface ReportFilterData {
  maintenanceTypes: MaintenanceType[];
  locationsGroups: LocationGroup[];
  companies: Company[];
  segments: Segment[];
}

@Injectable({
  providedIn: 'root'
})
export class ReportFilterApi {
  constructor(private readonly apollo: Apollo) {}

  public async getFiltersData(): Promise<ReportFilterData> {
    const query = gql`
      query getReportFiltersData {
        locationsGroups (limit: 300, orderBy: name_asc, where: { archived: false }) {
          items {
            id
            name
          }
        }
        companies (limit: 500, orderBy: name_asc, where: { archived: false }) {
          items {
            id
            name
          }
        }
        segments (limit: 100, orderBy: name_asc, where: { archived: false }) {
          items {
            id
            name
          }
        }
        maintenanceTypes (limit: 100, orderBy: name_asc, where: { archived: false }) {
          items {
            id
            name
          }
        }
      }
    `;

    const { data } = await this.apollo.query<any>({ query }).toPromise();

    return {
      companies: data.companies.items,
      locationsGroups: data.locationsGroups.items,
      maintenanceTypes: data.maintenanceTypes.items,
      segments: data.segments.items
    };
  }
}

